import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../components/config";
import "../style/FichaSeguimiento.css";

const FichaSeguimiento = () => {
  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  };

  const [asignaciones, setAsignaciones] = useState([]);
  const [estudiantes, setEstudiantes] = useState([]);
  const [historial, setHistorial] = useState([]);

  const [filtro, setFiltro] = useState({
    estudiante_id: "",
    materia_id: ""
  });

  const [form, setForm] = useState({
    categoria: "general",
    prioridad: "media",
    asunto: "",
    descripcion: "",
    accion_tomada: "",
    compromiso_estudiante: "",
    compromiso_padre: "",
    requiere_citacion: false,
    fecha_citacion: "",
    archivo: null
  });

  /* =====================================================
     CARGA INICIAL
  ===================================================== */
  useEffect(() => {
    cargarAsignaciones();
  }, []);

  const cargarAsignaciones = async () => {
    try {
      const res = await axios.get(`${API}/ficha-seguimiento/asignaciones`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setAsignaciones(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("❌ Error asignaciones:", err);
    }
  };

  const cargarEstudiantes = async (grado, grupo) => {
    try {
      const res = await axios.get(`${API}/ficha-seguimiento/estudiantes`, {
        params: { grado, grupo },
        headers: { Authorization: `Bearer ${token}` }
      });

      setEstudiantes(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("❌ Error estudiantes:", err);
    }
  };

  const cargarHistorial = async (id) => {
    try {
      const res = await axios.get(`${API}/ficha-seguimiento/estudiante/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setHistorial(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("❌ Error historial:", err);
    }
  };

  /* =====================================================
     CREAR REGISTRO
  ===================================================== */
  const guardar = async () => {
    if (!filtro.estudiante_id) {
      return alert("Seleccione estudiante");
    }

    if (!form.asunto || !form.descripcion) {
      return alert("Asunto y descripción obligatorios");
    }

    try {
      const fd = new FormData();

      fd.append("estudiante_id", filtro.estudiante_id);
      fd.append("categoria", form.categoria);
      fd.append("prioridad", form.prioridad);
      fd.append("asunto", form.asunto);
      fd.append("descripcion", form.descripcion);
      fd.append("accion_tomada", form.accion_tomada);
      fd.append("compromiso_estudiante", form.compromiso_estudiante);
      fd.append("compromiso_padre", form.compromiso_padre);
      fd.append("requiere_citacion", form.requiere_citacion);
      fd.append("fecha_citacion", form.fecha_citacion);

      if (form.archivo) {
        fd.append("archivo", form.archivo);
      }

      await axios.post(`${API}/ficha-seguimiento`, fd, axiosConfig);

      alert("✅ Registro guardado");

      setForm({
        categoria: "general",
        prioridad: "media",
        asunto: "",
        descripcion: "",
        accion_tomada: "",
        compromiso_estudiante: "",
        compromiso_padre: "",
        requiere_citacion: false,
        fecha_citacion: "",
        archivo: null
      });

      cargarHistorial(filtro.estudiante_id);

    } catch (err) {
      console.error("❌ Error guardar:", err);
      alert("Error guardando");
    }
  };

  /* =====================================================
     CAMBIAR ESTADO
  ===================================================== */
  const cambiarEstado = async (id, estado) => {
    try {
      await axios.patch(`${API}/ficha-seguimiento/estado/${id}`, { estado }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      cargarHistorial(filtro.estudiante_id);
    } catch (err) {
      console.error(err);
    }
  };

  const colorPrioridad = (p) => {
    if (p === "critica") return "#c0392b";
    if (p === "alta") return "#e67e22";
    if (p === "media") return "#2980b9";
    return "#7f8c8d";
  };

  return (
    <div className="fs-container">

      <h2>📂 Ficha Integral de Seguimiento Estudiantil</h2>

      {/* FILTROS */}
      <div className="fs-grid">

        <div>
          <label>Asignación Docente</label>
          <select onChange={(e) => {
            const asig = asignaciones.find(a => a.id == e.target.value);
            if (!asig) return;
            cargarEstudiantes(asig.grado, asig.grupo);
          }}>
            <option value="">Seleccione...</option>
            {asignaciones.map(a => (
              <option key={a.id} value={a.id}>
                {a.materia} - {a.grado}°{a.grupo}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Estudiante</label>
          <select
            value={filtro.estudiante_id}
            onChange={(e) => {
              setFiltro({ ...filtro, estudiante_id: e.target.value });
              cargarHistorial(e.target.value);
            }}
          >
            <option value="">Seleccione...</option>
            {estudiantes.map(e => (
              <option key={e.id} value={e.id}>
                {e.nombres_estudiante} {e.apellidos_estudiante}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* FORMULARIO */}
      <div className="fs-card">

        <div className="fs-grid-2">
          <div>
            <label>Categoría</label>
            <select value={form.categoria}
              onChange={(e) => setForm({ ...form, categoria: e.target.value })}>
              <option value="general">General</option>
              <option value="academico">Académico</option>
              <option value="disciplinario">Disciplinario</option>
              <option value="convivencia">Convivencia</option>
              <option value="inasistencia">Inasistencia</option>
              <option value="psicorientacion">Psicorientación</option>
              <option value="familiar">Familiar</option>
              <option value="salud">Salud</option>
            </select>
          </div>

          <div>
            <label>Prioridad</label>
            <select value={form.prioridad}
              onChange={(e) => setForm({ ...form, prioridad: e.target.value })}>
              <option value="baja">Baja</option>
              <option value="media">Media</option>
              <option value="alta">Alta</option>
              <option value="critica">Crítica</option>
            </select>
          </div>
        </div>

        <input
          placeholder="Asunto del seguimiento"
          value={form.asunto}
          onChange={(e) => setForm({ ...form, asunto: e.target.value })}
        />

        <textarea
          placeholder="Descripción detallada"
          value={form.descripcion}
          onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
        />

        <textarea
          placeholder="Acción tomada"
          value={form.accion_tomada}
          onChange={(e) => setForm({ ...form, accion_tomada: e.target.value })}
        />

        <textarea
          placeholder="Compromiso del estudiante"
          value={form.compromiso_estudiante}
          onChange={(e) => setForm({ ...form, compromiso_estudiante: e.target.value })}
        />

        <textarea
          placeholder="Compromiso del acudiente"
          value={form.compromiso_padre}
          onChange={(e) => setForm({ ...form, compromiso_padre: e.target.value })}
        />

        <div className="fs-grid-2">
          <label>
            <input
              type="checkbox"
              checked={form.requiere_citacion}
              onChange={(e) => setForm({ ...form, requiere_citacion: e.target.checked })}
            />
            Requiere Citación
          </label>

          <input
            type="date"
            value={form.fecha_citacion}
            onChange={(e) => setForm({ ...form, fecha_citacion: e.target.value })}
          />
        </div>

        <input
          type="file"
          onChange={(e) => setForm({ ...form, archivo: e.target.files[0] })}
        />

        <button onClick={guardar}>💾 Guardar Seguimiento</button>
      </div>

      {/* HISTORIAL */}
      <div className="fs-history">
        <h3>🕓 Historial Cronológico</h3>

        {historial.map(item => (
          <div
            key={item.id}
            className="fs-item"
            style={{ borderLeft: `6px solid ${colorPrioridad(item.prioridad)}` }}
          >
            <div className="fs-top">
              <strong>{item.asunto}</strong>
              <span>{item.categoria}</span>
            </div>

            <p>{item.descripcion}</p>

            {item.accion_tomada && <p><b>Acción:</b> {item.accion_tomada}</p>}
            {item.compromiso_estudiante && <p><b>Comp. Estudiante:</b> {item.compromiso_estudiante}</p>}
            {item.compromiso_padre && <p><b>Comp. Acudiente:</b> {item.compromiso_padre}</p>}

            <small>
              {new Date(item.fecha_registro).toLocaleString()}
            </small>

            <div className="fs-actions">
              <button onClick={() => cambiarEstado(item.id, "abierto")}>Abierto</button>
              <button onClick={() => cambiarEstado(item.id, "en_proceso")}>En Proceso</button>
              <button onClick={() => cambiarEstado(item.id, "cerrado")}>Cerrar</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FichaSeguimiento;
